module.exports = __webpack_public_path__ + "img/jieshao.7972a1d4.png";